module.exports = __webpack_public_path__ + "img/11825375_L.9ae0ff71.png";